import React, { useEffect, useState } from 'react';
import ResponsiveContainer from '../../components/layout/ResponsiveContainer';
import SettingsCard from '../../components/ui/SettingsCard';
import { useApi } from '@/lib/useApi';

interface AdminUser { id: string; email: string; clerkId?: string | null; createdAt: string; }

export default function AdminManage() {
  const api = useApi();
  const [admins, setAdmins] = useState<AdminUser[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  const load = async () => {
    try {
      setLoading(true);
      const res = await api.get<{ users: AdminUser[] }>(`/api/admin/users?role=ADMIN`);
      setAdmins(res.users || []);
    } catch (e: any) {
      setError(e?.message || 'Failed to load admins');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => { load(); }, []);

  return (
    <ResponsiveContainer className="container">
      <div className="content">
        <div style={{ marginBottom: 24 }}>
          <h1 style={{ fontSize: 28 }}>Manage Admins</h1>
          <p style={{ color: '#6b7280' }}>View and remove admin accounts</p>
        </div>

        {error && <div style={{ color: '#b91c1c', marginBottom: 12 }}>{error}</div>}

        <SettingsCard title={`Admins (${admins.length})`}>
          {loading ? (
            <div style={{ padding: 16 }}>Loading…</div>
          ) : admins.length === 0 ? (
            <div style={{ padding: 16, color: '#6b7280' }}>No admins found.</div>
          ) : (
            <div className="space-y-3">
              {admins.map(u => (
                <div key={u.id} style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '12px 0', borderBottom: '1px solid #e5e7eb' }}>
                  <div>
                    <div style={{ fontWeight: 600 }}>{u.email}</div>
                    <div style={{ fontSize: 12, color: '#6b7280' }}>Created {new Date(u.createdAt).toLocaleString()}</div>
                  </div>
                  <div>
                    <button
                      onClick={async () => {
                        if (!confirm(`Permanently delete admin ${u.email}?`)) return;
                        try {
                          await api.del(`/api/admin/users/${u.id}`);
                          await load();
                        } catch {
                          alert('Failed to delete admin');
                        }
                      }}
                      className="btn btn-danger"
                      style={{ background: '#dc2626', color: 'white' }}
                    >
                      Delete
                    </button>
                  </div>
                </div>
              ))}
            </div>
          )}
        </SettingsCard>
      </div>
    </ResponsiveContainer>
  );
}


